// AdventureBackground.js - Updated with simple plane background
import React from "react";
import {
  FaPlane,
  FaMountain,
  FaMapMarkedAlt,
  FaCompass,
} from "react-icons/fa";

const AdventureBackground = ({ header, children, footer }) => {
  return (
    <>
      {/* SIMPLE CLEAN BACKGROUND */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        {/* Base gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50" />
        
        {/* Subtle texture overlay */}
        <div 
          className="absolute inset-0 opacity-5 pointer-events-none"
          style={{
            backgroundImage: `
              radial-gradient(circle at 25% 25%, #06b6d4 2px, transparent 2px),
              radial-gradient(circle at 75% 75%, #3b82f6 2px, transparent 2px),
              radial-gradient(circle at 50% 50%, #8b5cf6 2px, transparent 2px)
            `,
            backgroundSize: '100px 100px, 150px 150px, 200px 200px',
          }}
        />
        
        {/* Floating decorative elements */}
        <div className="absolute top-1/4 right-1/4 opacity-10">
          <FaPlane className="w-16 h-16 text-blue-400 animate-float-slow" />
        </div>
        <div className="absolute bottom-1/3 left-1/4 opacity-10">
          <FaCompass className="w-12 h-12 text-cyan-400 animate-float-slow delay-1000" />
        </div>
        <div className="absolute top-1/3 left-1/3 opacity-10">
          <FaMapMarkedAlt className="w-10 h-10 text-purple-400 animate-float-slow delay-2000" />
        </div>
      </div>

      {/* APP CONTENT */}
      <div className="relative z-10 min-h-screen flex flex-col">
        <header className="relative z-20">{header}</header>
        <main className="flex-grow relative z-10">{children}</main>
        <footer className="relative z-20">{footer}</footer>
      </div>

      {/* ANIMATIONS */}
      <style jsx="true">{`
        @keyframes float-slow {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(2deg); }
        }
        
        .animate-float-slow {
          animation: float-slow 8s ease-in-out infinite;
        }
      `}</style>
    </>
  );
};

export default AdventureBackground;